import { default as i18n } from "i18next";
import { initReactI18next } from "react-i18next";

import { ru } from "./locales/ru";
import { LANGUAGE_KEYS } from "./model/language-keys";

i18n.use(initReactI18next).init({
  resources: {
    RU: {
      translation: ru,
    },
  },
  lng: LANGUAGE_KEYS.RU,
  fallbackLng: LANGUAGE_KEYS.RU,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
